module.exports = __webpack_public_path__ + "img/l200_base.707657e1.jpg";